package app.bloomey.web.modules.users

import app.bloomey.web.core.data.UiState
import app.bloomey.web.core.data.models.PageResponse
import app.bloomey.web.core.data.models.UpdateUserRequest
import app.bloomey.web.core.data.models.User
import app.bloomey.web.utils.ApiError
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow

class UsersRepository {

    private val api = UserApi()
    fun getUsers(page: Int, size: Int, query: String): Flow<UiState<PageResponse<List<User>>>> = flow {
        try {
            emit(UiState.Loading)
            val response = api.getUsers(page, size, query)
            emit(UiState.Success(response.data))
        } catch (e: Throwable) {
            emit(UiState.Error(ApiError.parseMessage(e, "Unable to get Data")))
        }
    }

    fun updateUser(id: String, request: UpdateUserRequest) = flow<UiState<User>> {
        try {
            emit(UiState.Loading)
            val response = api.updateUser(id, request)
            emit(UiState.Success(response.data))
        } catch (e: Throwable) {
            emit(UiState.Error(ApiError.parseMessage(e)))
        }
    }

    fun deleteUsers(idList: List<String>) = flow<UiState<String>> {
        try {
            emit(UiState.Loading)
            val response = api.deleteUsers(idList)
            emit(UiState.Success(response.data))
        } catch (e: Throwable) {
            emit(UiState.Error(ApiError.parseMessage(e)))
        }
    }

    fun deleteUser(id: String) = flow<UiState<Boolean>> {
        try {
            emit(UiState.Loading)
            val response = api.deleteUser(id)
            emit(UiState.Success(response.data))
        } catch (e: Throwable) {
            emit(UiState.Error(ApiError.parseMessage(e)))
        }
    }

    fun getUser(userId: String) = flow<UiState<User>> {
        try {
            emit(UiState.Loading)
            val response = api.getUser(userId)
            emit(UiState.Success(response.data))
        } catch (e: Throwable) {
            emit(UiState.Error(ApiError.parseMessage(e)))
        }
    }

}
